import { Lock } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconLock12Line = createIcon(Lock, 12, "Line");
export const IconLock16Line = createIcon(Lock, 16, "Line");
export const IconLock20Line = createIcon(Lock, 20, "Line");
export const IconLock24Line = createIcon(Lock, 24, "Line");
export const IconLock32Line = createIcon(Lock, 32, "Line");
export const IconLock48Line = createIcon(Lock, 48, "Line");
export const IconLock64Line = createIcon(Lock, 64, "Line");
